import React, { Component } from 'react';
import ViewHeader from '../../components/view-header';
import AppWrapper from '../../app-wrapper';
import BarGraphStacked from '../../components/bar-graph-stacked';
import ProductRecommendations from '../../components/product-recommendations';
import BusinessCaseBuilder from '../../components/business-case-builder';
import LegalInfo from '../../components/legal-info';
import CallToAction from '../../components/call-to-action';

class MarketComparisonView extends Component {
  componentWillMount() {
    const { startNewBusinessCase } = this.props.actions;
    startNewBusinessCase();
  }

  render() {
    const {
      routePaths,
      marketComparison = [],
      authorableContent,
      graphAuthorableContent,
      productRecommendation,
      totalBenefits,
    } = this.props;
    const { businessCase } = routePaths;
    const { viewHeaderContent } = authorableContent;
    return (
      <AppWrapper>
        <div className="root-container container market-comparison">
          <ViewHeader content={viewHeaderContent} />
          <div className="row graph-usage">
            <div className="col-sm-8 main-with-sidebar block-spacer">
              <BarGraphStacked
                authorableContent={graphAuthorableContent}
                data={marketComparison}
                totalBenefits={totalBenefits}
              />
              <ProductRecommendations />
            </div>
            <div className="col-sm-4 sidebar sidebar-with-cta sidebar block-spacer">
              <BusinessCaseBuilder totalBenefits={totalBenefits} />
              {productRecommendation.length > 0 &&
              <CallToAction
                buttonText={authorableContent.businessCaseBuilder.finaliseButtonText}
                buttonId="bcb-finalise-business-case-btn"
                customClasses="do-business"
                route={businessCase.route}
              />
              }
            </div>
          </div>
          <div className="row">
            <LegalInfo />
          </div>
        </div>
      </AppWrapper>
    );
  }
}

export default MarketComparisonView;
